// extracted by mini-css-extract-plugin
export default {"image":"ImageModal_image__8PdTc"};